import React, { useEffect, useState } from "react";
import CloudIcon from "../../../../Assets/Images/Wizard/upload-cloud.svg";
import Select from "../IconSelect";
import Switch from "../../../../Components/Dashboard/Components/ShareElements/TextInput/Switch";
import Checkbox from "../../../Dashboard/Components/ShareElements/Checkbox/Checkbox";
import TermsModal from "../TermsModal";
import ProfileImageUploader from "../ProfileImageUploader";
import { Config } from "../../../../Config";
import axios from "axios";

const Step1 = (props) => {
  const [CXtermsChecked, setCXtermsChecked] = useState(false);
  const [CompanytermsChecked, setCompanytermsChecked] = useState(false);
  const [LangSelected, setLangSelected] = useState(false);
  const [CurrencySelected, setCurrencySelected] = useState(false);
  const [CXTermsModalIsOpen, setCXTermsModalIsOpen] = useState(false);
  const [CompTermsModalIsOpen, setCompTermsModalIsOpen] = useState(false);
  const [Languages] = useState([
    {
      id: "EN",
      name: "English",
    },
    {
      id: "DE",
      name: "German",
    },
    // {
    //   id: "FR",
    //   name: "French",
    // },
    // {
    //   id: "ES",
    //   name: "Spanish",
    // },
  ]);
  const [Currencies, setCurrencies] = useState([
    {
      name: "U.S. Dollar (USD)",
      id: "USD",
    },
  ]);
  const [Terms] = useState({
    cx_terms:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aenean mauris parturient mollis vitae. Congue augue parturient vitae, laoreet. Mattis pellentesque molestie hac gravida vestibulum scelerisque viverra massa. Dolor nibh at pellentesque et, ipsum. Massa feugiat morbi dui, sed scelerisque. Ac donec dapibus ut sodales diam mauris vitae molestie. Tempor viverra sollicitudin varius mollis mi. In odio ultrices massa venenatis placerat mauris. Venenatis ornare viverra sit faucibus sed condimentum leo commodo. Eros, quisque aliquam sem et eget pulvinar dolor ultricies vel. Dolor sed lacus, vel elementum augue venenatis purus. Ultricies quis pretium ipsum eget id.Tincidunt quis urna, id non velit convallis. A vitae ac hendrerit risus aenean facilisis vulputate morbi. Donec accumsan id proin quis tempor at feugiat integer cursus. Nulla non quisque diam quam in tincidunt tortor. Dolor suspendisse facilisi mauris tellus ipsum quis massa mauris. Aliquam semper tempus, quis eu tortor cursus metus. Ac orci vitae suscipit dui, sit nisl maecenas. Tincidunt phasellus sagittis nulla nulla pellentesque feugiat. Ut mauris, diam eu at egestas nisl. Posuere faucibus et in lacus, pellentesque diam.Consectetur sed tellus senectus amet id sit cras id volutpat. Morbi tortor dolor pulvinar magna neque, nulla neque diam egestas. Morbi leo nunc eros mattis vitae viverra hac. Quis faucibus sollicitudin luctus ligula purus. Et enim curabitur malesuada purus, morbi. Amet, mauris ut sit ut. Pellentesque dui, lacus pharetra, vulputate porttitor eget in ut. Sit bibendum vitae fermentum, pretium velit erat eleifend gravida ut. Curabitur tempor porttitor scelerisque euismod bibendum accumsan. Fringilla porttitor eu sem vitae non consectetur in ac. Elit adipiscing elementum mi nunc metus.At convallis diam tristique semper leo sit. Ipsum eget sit faucibus nulla ultrices morbi tempus sed quis. Id nibh quam aenean pretium facilisi neque. Urna, sed pretium nisl proin in egestas. Id consequat sodales suspendisse et accumsan tempor gravida sollicitudin. Elementum odio semper pretium vitae, sodales eu in. Diam dignissim lobortis in vestibulum eu enim nec nunc. Pharetra elit tristique gravida leo et euismod aliquam. Porttitor aliquam neque urna nisl quisque elementum aliquam orci. Eget et faucibus arcu tellus faucibus ut auctor leo quis. Sed maecenas auctor tortor tortor nisi. Ac eu porttitor urna nunc dui, massa, ullamcorper. Malesuada purus, integer massa, quis amet posuere. Maecenas pharetra rutrum praesent lectus ac. Enim varius in sed lacus eget euismod.",
    company_terms:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aenean mauris parturient mollis vitae. Congue augue parturient vitae, laoreet. Mattis pellentesque molestie hac gravida vestibulum scelerisque viverra massa. Dolor nibh at pellentesque et, ipsum. Massa feugiat morbi dui, sed scelerisque. Ac donec dapibus ut sodales diam mauris vitae molestie. Tempor viverra sollicitudin varius mollis mi. In odio ultrices massa venenatis placerat mauris. Venenatis ornare viverra sit faucibus sed condimentum leo commodo. Eros, quisque aliquam sem et eget pulvinar dolor ultricies vel. Dolor sed lacus, vel elementum augue venenatis purus. Ultricies quis pretium ipsum eget id.Tincidunt quis urna, id non velit convallis. A vitae ac hendrerit risus aenean facilisis vulputate morbi. Donec accumsan id proin quis tempor at feugiat integer cursus. Nulla non quisque diam quam in tincidunt tortor. Dolor suspendisse facilisi mauris tellus ipsum quis massa mauris. Aliquam semper tempus, quis eu tortor cursus metus. Ac orci vitae suscipit dui, sit nisl maecenas. Tincidunt phasellus sagittis nulla nulla pellentesque feugiat. Ut mauris, diam eu at egestas nisl. Posuere faucibus et in lacus, pellentesque diam.Consectetur sed tellus senectus amet id sit cras id volutpat. Morbi tortor dolor pulvinar magna neque, nulla neque diam egestas. Morbi leo nunc eros mattis vitae viverra hac. Quis faucibus sollicitudin luctus ligula purus. Et enim curabitur malesuada purus, morbi. Amet, mauris ut sit ut. Pellentesque dui, lacus pharetra, vulputate porttitor eget in ut. Sit bibendum vitae fermentum, pretium velit erat eleifend gravida ut. Curabitur tempor porttitor scelerisque euismod bibendum accumsan. Fringilla porttitor eu sem vitae non consectetur in ac. Elit adipiscing elementum mi nunc metus.At convallis diam tristique semper leo sit. Ipsum eget sit faucibus nulla ultrices morbi tempus sed quis. Id nibh quam aenean pretium facilisi neque. Urna, sed pretium nisl proin in egestas. Id consequat sodales suspendisse et accumsan tempor gravida sollicitudin. Elementum odio semper pretium vitae, sodales eu in. Diam dignissim lobortis in vestibulum eu enim nec nunc. Pharetra elit tristique gravida leo et euismod aliquam. Porttitor aliquam neque urna nisl quisque elementum aliquam orci. Eget et faucibus arcu tellus faucibus ut auctor leo quis. Sed maecenas auctor tortor tortor nisi. Ac eu porttitor urna nunc dui, massa, ullamcorper. Malesuada purus, integer massa, quis amet posuere. Maecenas pharetra rutrum praesent lectus ac. Enim varius in sed lacus eget euismod.",
  });
  const [AvatarEditIsOpen, setAvatarEditIsOpen] = useState(false);
  const [UploadedAvatar, setUploadedAvatar] = useState();

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchCurrencies = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/user-info/wizard/findAllCurrencies",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createCurrencyData(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createCurrencyData = (CurrencyData) => {
    let CurrenciesArray = [];
    CurrencyData.map((Currency) => {
      let Name = Currency.Currency + " (" + Currency.AlphabeticCode + ")";
      CurrenciesArray.push({
        name: Name,
        id: Currency.AlphabeticCode,
      });
    });
    setCurrencies(CurrenciesArray);
  };

  const handleCXCheckboxChange = () => {
    if (document.getElementById("cx-terms").classList.length > 1) {
      setCXtermsChecked(false);
    } else {
      setCXtermsChecked(true);
    }
  };
  const handleCompanyCheckboxChange = () => {
    if (document.getElementById("company-terms").classList.length > 1) {
      setCompanytermsChecked(false);
    } else {
      setCompanytermsChecked(true);
    }
  };
  const handleLangSelectChange = () => {
    setLangSelected(true);
    props.SetLanguage();
  };
  const handleCurSelectChange = () => {
    setCurrencySelected(true);
  };

  //Profile image uploader functions
  const triggerUpload = () => {
    document.getElementById("profile-image").click();
  };
  const closeProfileImageUploader = () => {
    setAvatarEditIsOpen(false);
  };
  const removeAvatarImage = () => {
    document.getElementById("profile-image").value = "";
    setUploadedAvatar("");
  };
  const changeAvatarImage = () => {
    triggerUpload();
  };
  const avatarUploaded = (e) => {
    window.localStorage.removeItem("UploadedImage");
    if (e.target.files[0] === undefined) {
      return null;
    } else {
      setUploadedAvatar(e.target.files[0]);
      setAvatarEditIsOpen(true);
    }
  };

  return (
    <div className="step-body">
      <input
        type="file"
        id="profile-image"
        accept=".jpg , .png, .jpeg"
        className="hidden"
        onChange={(e) => avatarUploaded(e)}
      />
      {AvatarEditIsOpen ? (
        <ProfileImageUploader
          Close={() => closeProfileImageUploader()}
          RemoveImage={() => removeAvatarImage()}
          ChangeImage={() => changeAvatarImage()}
          FetchImage={() => null}
          Image={UploadedAvatar}
          LangData={props.LangData}
        />
      ) : null}
      {CXTermsModalIsOpen ? (
        <TermsModal
          Text={Terms.cx_terms}
          ModalTitle={translateText("cx_terms")}
          Close={() => setCXTermsModalIsOpen(false)}
          LangData={props.LangData}
        />
      ) : null}
      {CompTermsModalIsOpen ? (
        <TermsModal
          Text={Terms.company_terms}
          ModalTitle={
            translateText("company") +
            "ABC" +
            translateText("terms_and_conditions")
          }
          Close={() => setCompTermsModalIsOpen(false)}
          LangData={props.LangData}
        />
      ) : null}
      <section className="profile-image-area">
        <div className="upload-trigger" onClick={() => triggerUpload()}>
          {window.localStorage.getItem("UploadedImage") === null ||
          window.localStorage.getItem("UploadedImage").length < 1 ? (
            <img className="cloud" alt="" src={CloudIcon} />
          ) : null}

          {window.localStorage.getItem("UploadedImage") !== null &&
          window.localStorage.getItem("UploadedImage").length > 1 ? (
            <img
              alt=""
              className="uploaded-profile-image"
              src={window.localStorage.getItem("UploadedImage")}
            />
          ) : null}
        </div>
        <div className="trigger-info">
          <h2>{translateText("wizard_upload_your_profile_picture")}</h2>
          <p>{translateText("wizard_file_limit_info")}</p>
        </div>
      </section>
      <section className="step-row">
        <p className="row-label">
          {translateText("wizard_select_language")} <p>*</p>
        </p>
        <Select
          Options={Languages}
          Label={translateText("preferred_language")}
          IconClassName="feather-globe"
          Id="language"
          ChangeEvent={() => handleLangSelectChange()}
        />
      </section>
      <section className="step-row">
        <p className="row-label">
          {translateText("wizard_select_currency")} <p>*</p>
        </p>
        <Select
          Options={Currencies}
          Label={translateText("currency")}
          IconClassName="feather-dollar-sign"
          Id="currency"
          ChangeEvent={() => handleCurSelectChange()}
        />
      </section>
      <section className="step-row step-row-flex switch-input">
        <p className="row-label">{translateText("wizard_stay_annonymous")}</p>
        <Switch Id="annonymous" Name="" IsActive ChangeEvent={() => null} />
      </section>
      <section className="step-row step-row-flex checkbox-input">
        <Checkbox Id="cx-terms" ChangeEvent={() => handleCXCheckboxChange()} />
        <p className="row-label" onClick={() => setCXTermsModalIsOpen(true)}>
          {translateText("wizard_accept_cx_terms")}
        </p>
        <p className="mandatory">*</p>
      </section>
      <section className="step-row step-row-flex checkbox-input">
        <Checkbox
          Id="company-terms"
          ChangeEvent={() => handleCompanyCheckboxChange()}
        />
        <p className="row-label" onClick={() => setCompTermsModalIsOpen(true)}>
          {translateText("wizard_accept_company_terms")}
        </p>
        <p className="mandatory">*</p>
      </section>
      {CXtermsChecked &&
      CompanytermsChecked &&
      CurrencySelected &&
      LangSelected ? (
        <button
          className="form-action-btn"
          onClick={() => props.TriggerNextStep()}
        >
          {translateText("next")}
        </button>
      ) : (
        <button className="form-action-btn disabled-btn">
          {translateText("next")}
        </button>
      )}
    </div>
  );
};

export default Step1;
